import React from "react";
import PropTypes from "prop-types";
import style from "../../../assets/css/styles.module.scss";
import DownloadIcon from "../../../assets/images/icons/download.svg";
import UpDownIcon from "../../../assets/images/icons/arrow-up-down.svg";

const ResultsView = ({ searchResults, resultsFieldNames, inputs, close, onSelect, downloadImg, sortImg, sortBy }) => {
  const generateSearchHeaderView = () => {
    const resultsTableHeader = [<th key="empty" />];
    const data = resultsFieldNames.length ? [...resultsFieldNames] : [...inputs];

    let count = 0;
    data.forEach(v => {
      count += 1;
      resultsTableHeader.push(
        <th key={count} onClick={() => sortBy(v.name)}>
          {sortImg || <img src={UpDownIcon} alt="sort" />}
          <span>{v.label}</span>
        </th>
      );
    });
    return resultsTableHeader;
  };

  const generateSearchBodyView = () => {
    const resultsTableBody = [];
    let resultRow = [];
    let count = 0;
    let countTd = 0;
    searchResults.forEach(row => {
      countTd += 1;
      count += 1;
      resultRow.push([
        <td key={countTd}>
          <button
            type="button"
            className={style.simpleButton}
            onClick={() => {
              close();
              onSelect(row);
            }}
          >
            {downloadImg || <img src={DownloadIcon} alt="download" />}
          </button>
        </td>
      ]);
      if (resultsFieldNames.length) {
        Object.keys(row).forEach(v => {
          countTd += 1;
          if (resultsFieldNames.find(field => field.element === v)) {
            resultRow.push([<td key={countTd}>{row[v]}</td>]);
          }
        });
      } else {
        Object.keys(row).forEach(v => {
          countTd += 1;
          resultRow.push([<td key={countTd}>{row[v]}</td>]);
        });
      }
      resultsTableBody.push(<tr key={count}>{resultRow}</tr>);
      resultRow = [];
    });
    return resultsTableBody;
  };

  return (
    <table key="results" className={style.resultsView}>
      <thead>
        <tr key="header" data-key="header">
          {generateSearchHeaderView()}
        </tr>
      </thead>
      <tbody>{generateSearchBodyView()}</tbody>
    </table>
  );
};

ResultsView.displayName = "ResultsView";

ResultsView.defaultProps = {
  downloadImg: null,
  sortImg: null
};

ResultsView.propTypes = {
  searchResults: PropTypes.array.isRequired,
  resultsFieldNames: PropTypes.array.isRequired,
  inputs: PropTypes.array.isRequired,
  close: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  sortBy: PropTypes.func.isRequired,
  downloadImg: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  sortImg: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default ResultsView;
